module.exports = function() {
  return new Worker(__webpack_public_path__ + "ac96910ec293b6753397.worker.js");
};